const config = module.exports
const wsProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
config.APIBase = process.env.API_BASE || '/api'
config.WSBase = process.env.WS_BASE || `${wsProtocol}${window.location.host}`
